function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Paper, Alert, CircularProgress, Card, CardContent, Popper, MenuList, MenuItem, ClickAwayListener } from '@mui/material';
import { Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon, MoreVert as MoreIcon, CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { ConfirmationDialog } from '../components/ConfirmationDialog';
import ApplicationModal from '../components/ApplicationModal';
import { UserAPI } from '../apis/UserAPI';
import { isAuthorized } from '../utils/utilities';
import authenticatedRoute from '../views/AuthenticatedRoute';
import { constants } from '../constants';
import { useThemeDetails } from '../components/ThemeDetailsContext';
var ApplicationManagement = function ApplicationManagement() {
    var _useThemeDetails = useThemeDetails(), stateImages = _useThemeDetails.stateImages;
    var _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), applications = _useState2[0], setApplications = _useState2[1];
    var _useState3 = useState(true), _useState4 = _slicedToArray(_useState3, 2), dataLoading = _useState4[0], setDataLoading = _useState4[1];
    var _useState5 = useState(null), _useState6 = _slicedToArray(_useState5, 2), error = _useState6[0], setError = _useState6[1];
    var _useState7 = useState(null), _useState8 = _slicedToArray(_useState7, 2), anchorEl = _useState8[0], setAnchorEl = _useState8[1];
    var _useState9 = useState(null), _useState0 = _slicedToArray(_useState9, 2), selectedMenuApp = _useState0[0], setSelectedMenuApp = _useState0[1];
    // Modal and dialog state
    var _useState1 = useState(false), _useState10 = _slicedToArray(_useState1, 2), applicationModalOpen = _useState10[0], setApplicationModalOpen = _useState10[1];
    var _useState11 = useState(null), _useState12 = _slicedToArray(_useState11, 2), selectedApplication = _useState12[0], setSelectedApplication = _useState12[1];
    var _useState13 = useState(null), _useState14 = _slicedToArray(_useState13, 2), selectedCard = _useState14[0], setSelectedCard = _useState14[1];
    var _useState15 = useState(false), _useState16 = _slicedToArray(_useState15, 2), deleteDialogOpen = _useState16[0], setDeleteDialogOpen = _useState16[1];
    var _useState17 = useState(null), _useState18 = _slicedToArray(_useState17, 2), applicationToDelete = _useState18[0], setApplicationToDelete = _useState18[1];
    var _useState19 = useState(false), _useState20 = _slicedToArray(_useState19, 2), loading = _useState20[0], setLoading = _useState20[1];
    var _useState21 = useState(''), _useState22 = _slicedToArray(_useState21, 2), successMessage = _useState22[0], setSuccessMessage = _useState22[1];
    var _useState23 = useState(null), _useState24 = _slicedToArray(_useState23, 2), modalError = _useState24[0], setModalError = _useState24[1];
    // Load data on component mount
    useEffect(function () {
        loadInitialData();
    }, []);
    var loadInitialData = /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
            var response, apps, transformedApps, _t;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.p = _context.n) {
                        case 0:
                            setDataLoading(true);
                            setError(null);
                            _context.p = 1;
                            _context.n = 2;
                            return UserAPI.getAllApplications();
                        case 2:
                            response = _context.v;
                            apps = response.resource || response; // Transform applications to include dateAdded
                            transformedApps = apps.map(function (app) {
                                var _app$metadata;
                                return _objectSpread(_objectSpread({}, app), {}, {
                                    dateAdded: (_app$metadata = app.metadata) !== null && _app$metadata !== void 0 && _app$metadata.createdDate ? new Date(app.metadata.createdDate).toLocaleDateString('en-US', {
                                        month: 'short',
                                        day: 'numeric',
                                        year: 'numeric'
                                    }) : constants.application_page_unknown_date
                                });
                            });
                            setApplications(transformedApps);
                            _context.n = 4;
                            break;
                        case 3:
                            _context.p = 3;
                            _t = _context.v;
                            console.error('Failed to load applications:', _t);
                            setError(constants.application_page_load_failed);
                            setApplications([]);
                        case 4:
                            _context.p = 4;
                            setDataLoading(false);
                            return _context.f(4);
                        case 5:
                            return _context.a(2);
                    }
            }, _callee, null, [[1, 3, 4, 5]]);
        }));
        return function loadInitialData() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAddApplication = function handleAddApplication() {
        setSelectedApplication(null);
        setModalError(null);
        setApplicationModalOpen(true);
    };
    var handleEditApplication = function handleEditApplication(app) {
        setSelectedApplication(app);
        setModalError(null);
        setApplicationModalOpen(true);
    };
    var handleDeleteApplication = function handleDeleteApplication(app) {
        setApplicationToDelete(app);
        setDeleteDialogOpen(true);
    };
    var handleSaveApplication = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(formData, imagePreview) {
            var _selectedApplication$, details, organizationId, response, newApp, _t2;
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.p = _context2.n) {
                        case 0:
                            setLoading(true);
                            setModalError(null);
                            _context2.p = 1;
                            if (formData.name.trim()) {
                                _context2.n = 2;
                                break;
                            }
                            setModalError(constants.application_modal_error_name_required);
                            setLoading(false);
                            return _context2.a(2);
                        case 2:
                            if (formData.type.trim()) {
                                _context2.n = 3;
                                break;
                            }
                            setModalError(constants.application_modal_error_type_required);
                            setLoading(false);
                            return _context2.a(2);
                        case 3:
                            if (formData.productName.trim()) {
                                _context2.n = 4;
                                break;
                            }
                            setModalError(constants.application_modal_error_product_name_required);
                            setLoading(false);
                            return _context2.a(2);
                        case 4:
                            if (formData.url.trim()) {
                                _context2.n = 5;
                                break;
                            }
                            setModalError(constants.application_modal_error_url_required);
                            setLoading(false);
                            return _context2.a(2);
                        case 5:
                            details = _objectSpread(_objectSpread({}, selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.details), {}, {
                                productName: formData.productName.trim(),
                                productUrl: formData.url.trim(),
                                applicationDescription: formData.applicationDescription.trim(),
                                applicationState: formData.applicationState ? 'active' : 'inactive',
                                // Include image if it's new, otherwise keep existing
                                image_base64: imagePreview || (selectedApplication === null || selectedApplication === void 0 || (_selectedApplication$ = selectedApplication.details) === null || _selectedApplication$ === void 0 ? void 0 : _selectedApplication$.image_base64)
                            });
                            if (!selectedApplication) {
                                _context2.n = 7;
                                break;
                            }
                            _context2.n = 6;
                            return UserAPI.updateApplication(selectedApplication.id, {
                                organization_id: selectedApplication.organization_id,
                                name: formData.name.trim(),
                                type: formData.type,
                                description: formData.description.trim(),
                                details: details
                            });
                        case 6:
                            // Update local state
                            setApplications(function (prevApps) {
                                return prevApps.map(function (app) {
                                    return app.id === selectedApplication.id ? _objectSpread(_objectSpread({}, app), {}, {
                                        name: formData.name.trim(),
                                        type: formData.type,
                                        description: formData.description.trim(),
                                        details: details
                                    }) : app;
                                });
                            });
                            setSuccessMessage(constants.application_page_updated_success);
                            _context2.n = 9;
                            break;
                        case 7:
                            // Create new application
                            // Get organization_id from first existing application or use a default
                            organizationId = applications.length > 0 ? applications[0].organization_id : 1;
                            _context2.n = 8;
                            return UserAPI.createApplication({
                                organization_id: organizationId,
                                name: formData.name.trim(),
                                type: formData.type,
                                description: formData.description.trim(),
                                details: details
                            });
                        case 8:
                            response = _context2.v;
                            // Add new application to local state
                            newApp = {
                                id: response.id,
                                name: formData.name.trim(),
                                type: formData.type,
                                description: formData.description.trim(),
                                organization_id: response.organization_id,
                                resourceType: 'Application',
                                metadata: response.metadata || {
                                    versionId: 1,
                                    createdDate: new Date().toISOString(),
                                    updatedDate: new Date().toISOString(),
                                    createdBy: 'current_user',
                                    updatedBy: 'current_user'
                                },
                                details: response.details || details,
                                dateAdded: new Date().toLocaleDateString('en-US', {
                                    month: 'short',
                                    day: 'numeric',
                                    year: 'numeric'
                                })
                            };
                            setApplications(function (prevApps) {
                                return [].concat(_toConsumableArray(prevApps), [newApp]);
                            });
                            setSuccessMessage(constants.application_page_created_success);
                        case 9:
                            setApplicationModalOpen(false);
                            setSelectedApplication(null);
                            setModalError(null);
                            _context2.n = 11;
                            break;
                        case 10:
                            _context2.p = 10;
                            _t2 = _context2.v;
                            console.error('Error saving application:', _t2);
                            setModalError(_t2 instanceof Error ? _t2.message : constants.application_page_save_failed);
                        case 11:
                            _context2.p = 11;
                            setLoading(false);
                            return _context2.f(11);
                        case 12:
                            return _context2.a(2);
                    }
            }, _callee2, null, [[1, 10, 11, 12]]);
        }));
        return function handleSaveApplication(_x, _x2) {
            return _ref2.apply(this, arguments);
        };
    }();
    var confirmDeleteApplication = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
            var _t3;
            return _regenerator().w(function (_context3) {
                while (1)
                    switch (_context3.p = _context3.n) {
                        case 0:
                            if (!applicationToDelete) {
                                _context3.n = 5;
                                break;
                            }
                            setLoading(true);
                            setError(null);
                            _context3.p = 1;
                            _context3.n = 2;
                            return UserAPI.deleteApplication(applicationToDelete.id);
                        case 2:
                            setApplications(function (prevApps) {
                                return prevApps.filter(function (a) {
                                    return a.id !== applicationToDelete.id;
                                });
                            });
                            setSuccessMessage(constants.application_page_deleted_success);
                            setDeleteDialogOpen(false);
                            setApplicationToDelete(null);
                            _context3.n = 4;
                            break;
                        case 3:
                            _context3.p = 3;
                            _t3 = _context3.v;
                            console.error('Error deleting application:', _t3);
                            setError(constants.application_page_delete_failed);
                        case 4:
                            _context3.p = 4;
                            setLoading(false);
                            return _context3.f(4);
                        case 5:
                            return _context3.a(2);
                    }
            }, _callee3, null, [[1, 3, 4, 5]]);
        }));
        return function confirmDeleteApplication() {
            return _ref3.apply(this, arguments);
        };
    }();
    // Check view permission
    if (!isAuthorized('RBAC:ViewApplication')) {
        return /*#__PURE__*/ React.createElement(Box, {
            sx: {
                p: 3,
                bgcolor: '#f8f8f8'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                textAlign: 'center',
                py: 8
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            color: "#666",
            gutterBottom: true
        }, constants.application_page_access_denied), /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            color: "#888"
        }, constants.application_page_no_permission)));
    }
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            bgcolor: '#ffffff'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            p: 3
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            color: '#595959'
        }
    }, constants.application_page_description), isAuthorized('RBAC:CreateApplication') && /*#__PURE__*/ React.createElement(Button, {
        variant: "contained",
        startIcon: /*#__PURE__*/ React.createElement(AddIcon, null),
        onClick: handleAddApplication,
        sx: {
            textTransform: 'none',
            boxShadow: 'none',
            backgroundColor: '#26890d',
            '&:hover': {
                backgroundColor: '#1f6b0a'
            }
        }
    }, "Application")), dataLoading && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            textAlign: 'center',
            py: 4
        }
    }, stateImages !== null && stateImages !== void 0 && stateImages.Loading ? /*#__PURE__*/ React.createElement(Box, {
        component: "img",
        src: stateImages.Loading,
        alt: "Loading",
        sx: {
            width: 128,
            height: 128
        }
    }) : /*#__PURE__*/ React.createElement(CircularProgress, null), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            mt: 2
        }
    }, constants.application_page_loading)), error && /*#__PURE__*/ React.createElement(Alert, {
        severity: "error",
        sx: {
            mb: 3
        }
    }, error), successMessage && /*#__PURE__*/ React.createElement(Alert, {
        severity: "success",
        sx: {
            mb: 3
        },
        onClose: function onClose() {
            return setSuccessMessage('');
        }
    }, successMessage), !dataLoading && !error && /*#__PURE__*/ React.createElement(React.Fragment, null, applications.length === 0 ? /*#__PURE__*/ React.createElement(Box, {
        sx: {
            textAlign: 'center',
            py: 6,
            color: '#595959'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, "No applications found")) : /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'grid',
            gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(2, 1fr)',
                md: 'repeat(3, 1fr)',
                lg: 'repeat(5, 1fr)'
            },
            gap: 3
        }
    }, applications.map(function (app) {
        var _app$details, _app$details2;
        var isSelected = (selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.id) === app.id;
        return /*#__PURE__*/ React.createElement(Card, {
            key: app.id,
            onClick: function onClick() {
                return setSelectedCard((selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.id) === app.id ? null : app);
            },
            sx: {
                width: '100%',
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#FFFFFF',
                border: isSelected ? '2px solid #26890d' : '1px solid #d9d9d9',
                borderRadius: '12px',
                boxShadow: isSelected ? '0 0 0 2px rgba(38, 137, 13, 0.1)' : 'none',
                cursor: 'pointer',
                position: 'relative',
                transition: 'all 0.2s ease',
                '&:hover': {
                    boxShadow: isSelected ? '0 0 0 2px rgba(38, 137, 13, 0.2)' : '0 2px 8px rgba(0, 0, 0, 0.08)',
                    border: isSelected ? '2px solid #26890d' : '1px solid #bdbdbd'
                }
            }
        }, isSelected && /*#__PURE__*/ React.createElement(Box, {
            sx: {
                position: 'absolute',
                top: 12,
                right: 12,
                zIndex: 10
            }
        }, /*#__PURE__*/ React.createElement(Button, {
            size: "small",
            onClick: function onClick(e) {
                e.stopPropagation();
                setAnchorEl(e.currentTarget);
                setSelectedMenuApp(app);
            },
            sx: {
                minWidth: 'auto',
                p: 0.5,
                color: '#212121',
                '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.05)'
                }
            }
        }, /*#__PURE__*/ React.createElement(MoreIcon, {
            sx: {
                fontSize: '24px'
            }
        }))), isSelected && /*#__PURE__*/ React.createElement(Box, {
            sx: {
                position: 'absolute',
                top: 12,
                left: 12,
                zIndex: 10,
                backgroundColor: '#26890d',
                borderRadius: '50%',
                width: '24px',
                height: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }
        }, /*#__PURE__*/ React.createElement(CheckCircleIcon, {
            sx: {
                fontSize: '24px',
                color: '#ffffff'
            }
        })), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                position: 'relative',
                width: '100%',
                height: {
                    xs: '6.5rem',
                    sm: '8.5rem'
                },
                backgroundColor: '#F5F5F5',
                borderRadius: '12px 12px 0 0',
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.3s ease',
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: '#F5F5F5',
                    opacity: 0.6,
                    transition: 'opacity 0.3s ease',
                    pointerEvents: 'none',
                    borderRadius: '8px 8px 0 0'
                }
            }
        }, /*#__PURE__*/ React.createElement("img", {
            src: ((_app$details = app.details) === null || _app$details === void 0 ? void 0 : _app$details.image_base64) || 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 100 100%22%3E%3Crect fill=%22%23f0f0f0%22 width=%22100%22 height=%22100%22/%3E%3C/svg%3E',
            alt: "".concat(app.name, " logo"),
            style: {
                height: '100%',
                width: '100%',
                objectFit: 'cover'
            }
        })), /*#__PURE__*/ React.createElement(CardContent, {
            sx: {
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                p: '16px !important',
                gap: 1.5
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            color: "#121212",
            fontWeight: 600,
            sx: {
                mb: 0.5
            }
        }, app.name), /*#__PURE__*/ React.createElement(Typography, {
            variant: "body2",
            color: "#545454ff",
            component: "div",
            sx: {
                minHeight: 40,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                WebkitLineClamp: 6,
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical'
            }
        }, /*#__PURE__*/ React.createElement("span", {
            style: {
                fontWeight: 800
            }
        }, app.description || ''), /*#__PURE__*/ React.createElement(Box, {
            component: "span",
            display: "block"
        }, ((_app$details2 = app.details) === null || _app$details2 === void 0 ? void 0 : _app$details2.applicationDescription) || ''))));
    })))), /*#__PURE__*/ React.createElement(Popper, {
        open: Boolean(anchorEl),
        anchorEl: anchorEl,
        placement: "bottom-end",
        modifiers: [{
                name: 'offset',
                options: {
                    offset: [0, 4]
                }
            }],
        style: {
            zIndex: 1300
        }
    }, /*#__PURE__*/ React.createElement(ClickAwayListener, {
        onClickAway: function onClickAway() {
            setAnchorEl(null);
            setSelectedMenuApp(null);
        }
    }, /*#__PURE__*/ React.createElement(Paper, {
        sx: {
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
            borderRadius: '8px',
            border: '1px solid #e0e0e0',
            minWidth: '160px',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ React.createElement(MenuList, {
        sx: {
            py: 0.5
        }
    }, isAuthorized('RBAC:UpdateApplication') && /*#__PURE__*/ React.createElement(MenuItem, {
        onClick: function onClick() {
            if (selectedMenuApp) {
                handleEditApplication(selectedMenuApp);
            }
            setAnchorEl(null);
            setSelectedMenuApp(null);
        },
        sx: {
            py: 1,
            px: 2,
            fontSize: '14px',
            color: '#212121',
            '&:hover': {
                backgroundColor: '#f5f5f5'
            }
        }
    }, /*#__PURE__*/ React.createElement(EditIcon, {
        sx: {
            mr: 1.5,
            fontSize: '18px',
            color: '#595959'
        }
    }), constants.application_page_edit), isAuthorized('RBAC:DeleteApplication') && /*#__PURE__*/ React.createElement(MenuItem, {
        onClick: function onClick() {
            if (selectedMenuApp) {
                handleDeleteApplication(selectedMenuApp);
            }
            setAnchorEl(null);
            setSelectedMenuApp(null);
        },
        sx: {
            py: 1,
            px: 2,
            fontSize: '14px',
            color: '#212121',
            '&:hover': {
                backgroundColor: '#f5f5f5'
            }
        }
    }, /*#__PURE__*/ React.createElement(DeleteIcon, {
        sx: {
            mr: 1.5,
            fontSize: '18px',
            color: '#595959'
        }
    }), constants.application_page_delete))))), /*#__PURE__*/ React.createElement(ApplicationModal, {
        open: applicationModalOpen,
        onClose: function onClose() {
            setApplicationModalOpen(false);
            setSelectedApplication(null);
            setModalError(null);
        },
        onSave: handleSaveApplication,
        application: selectedApplication,
        loading: loading,
        error: modalError
    }), /*#__PURE__*/ React.createElement(ConfirmationDialog, {
        isOpen: deleteDialogOpen,
        setIsOpen: function setIsOpen() {
            setDeleteDialogOpen(false);
            setApplicationToDelete(null);
        },
        submitFunction: confirmDeleteApplication,
        bodyText: "Are you sure you want to delete \"".concat(applicationToDelete === null || applicationToDelete === void 0 ? void 0 : applicationToDelete.name, "\"? This action cannot be undone."),
        submitButtonText: "Delete",
        loading: loading
    }));
};
export default authenticatedRoute(ApplicationManagement);
